import { FormSection } from '@ksyos/design-system';
import type { BariPreAddGeneralPractitionerData } from '@common/validation/customControls/bariPre/bariPreAddGeneralPractitioner/v1/bariPreAddGeneralPractitionerSchemaV1';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { ProcessActivityCareProviderSelector } from '../../ProcessActivityCareProviderSelector';

export function BariPreAddGeneralPractitionerEdit(): JSX.Element {
    const { data, errors, onChange } = useProcessActivityEditContext<BariPreAddGeneralPractitionerData>();
    const { patient } = usePatientEpisodeCategoryContext();

    return (
        <FormSection>
            <ProcessActivityCareProviderSelector
                error={errors.get('generalPractitioner.organizationId')}
                generalPractitioner={data.generalPractitioner}
                isRequired={true}
                itemsPerPage={5}
                onChange={(organizationId, practitionerId) => {
                    onChange(
                        {
                            generalPractitioner: {
                                organizationId,
                                practitionerId,
                            },
                        },
                        'generalPractitioner.organizationId'
                    );
                }}
                patient={patient}
            />
        </FormSection>
    );
}
